module.exports = __webpack_public_path__ + "static/media/a-to-z.fc94f06f.svg";